// extracted by mini-css-extract-plugin
export default {"desktop6":"Desktop4_desktop6__b7qa+","leftContentWrapper":"Desktop4_leftContentWrapper__B5AOX"};